
// EmployeeAvatar.jsx
import React, { useState,useEffect } from 'react';
import { Button, Col, Container, Row } from "react-bootstrap";
import { Typography } from "@mui/material";
import '../EmployeeAvatar.css';

const EmployeeAvatar = ({ employee, isSuccessAuth }) => {
  const [isAnimating, setIsAnimating] = useState(false);
  
  useEffect(() => {
    if (isSuccessAuth) {
      setIsAnimating(true);
    }
  }, [isSuccessAuth]);

  return (
    <div 
      className={`employee-avatar ${isSuccessAuth && isAnimating ? 'animating' : ''}`}
      onAnimationEnd={() => setIsAnimating(false)}>
      <img 
        src={employee.profile_photo} 
        alt={employee.username} 
      />
    </div>  
  );
};

export default EmployeeAvatar;



